<script lang="ts">
	import { Button } from '@Shelly/shelly-design-system';
	import { CHANGE_DATE } from 'src/constants';
	import { save_home } from 'src/helpers/home_helpers';
	import { save_profile } from 'src/helpers/profile_helpers';

	const updateHomeDataGTCUpdate = () => {
		save_profile('gtc', {
			s: 1680455849,
		});
	};

	const updateHomeDataPPUpdate = () => {
		save_profile('pp', {
			s: 1680455849,
		});
	};

	const updateHomeDataDataActUpdate = () => {
		// mirror PP/GTC reset behavior for Data Act
		save_home('dataAct', {
			s: CHANGE_DATE.DA,
			agreed: false,
			last_seen: Math.floor(Date.now() / 1000), //epoch time in seconds
		});
	};
</script>

<div class="d-flex flex-direction-column">
	<Button class="width-md-xl width-sm-full mb-m " on:click={updateHomeDataGTCUpdate}
		>Reset GTC Update</Button
	>

	<Button class="width-md-xl width-sm-full mb-m" on:click={updateHomeDataPPUpdate}
		>Reset PP Update</Button
	>

	<Button class="width-md-xl width-sm-full mb-m" on:click={updateHomeDataDataActUpdate}
		>Reset Data Act Update</Button
	>
</div>
